import React, { Component } from "react";
import TruncateText from "../generic/TruncateText";
import classNames from "classnames";
import PropTypes from "prop-types";
import BookJacketFan from "react/views/bookJacket/BookJacketFan";

import "./series.less";

const backgroundGradient =
	"linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5))";

class Series extends Component {
	render() {
		const backgroundImage = `${backgroundGradient}, url(${
			this.props.bookJacketUrl
		})`;
		return (
			<div
				className={classNames("clickable", "similar-series", {
					"similar-series-last": this.props.isLastItem
				})}
				onClick={this.props.onClick}
				style={{ backgroundImage }}
			>
				<BookJacketFan
					bookJacketUrl={this.props.bookJacketUrl}
					title={this.props.title}
				/>

				<div className="similar-series-name">
					<TruncateText
						line={1}
						truncateText="..."
						text={this.props.title}
					/>
				</div>
			</div>
		);
	}
}

Series.propTypes = {
	bookJacketUrl: PropTypes.string,
	onClick: PropTypes.func.isRequired,
	title: PropTypes.string,
	isLastItem: PropTypes.bool
};

export default Series;



// WEBPACK FOOTER //
// ./src/react/views/series/Series.jsx